import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { boxStyles } from './styles.js';
import styled from 'styled-components';
var StyledBox =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Boxweb__StyledBox",
  componentId: "phd6kb-0"
})(["", ""], boxStyles);
/**
 * Quick style tweaks as component props
 */

var Box = function Box(_ref) {
  var boxRef = _ref.boxRef,
      props = _objectWithoutProperties(_ref, ["boxRef"]);

  return (
    /*#__PURE__*/
    React.createElement(StyledBox, _extends({
      "data-test": "elemental-Box",
      ref: boxRef
    }, props))
  );
};

export { Box, StyledBox };